export { default } from './Embed'
